<template>
    <v-dialog v-model="dialog" max-width="600">
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Confirmation</v-toolbar-title>
            </v-toolbar>
            <v-card-title>
                Are you sure you want to leave this page without saving this medical record?
            </v-card-title>
            <v-card-actions>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-alert text type="error" v-if="errorMessage">
                                {{errorMessage}}
                            </v-alert> 
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn color="primary darken-1" @click="confirm" :disabled="saving" :loading="saving" block>Confirm</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn color="warning" @click="cancel" block>Cancel</v-btn>
                                </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
     props: {
        dialog: {
            type: Boolean,
            default: false
        },
    } ,
    data() {
        return {
            errorMessage: "",
            saving: false
        };
    },
    methods: {
        async confirm() {
            await this.$emit("confirm");
        },
        cancel() {
            this.$emit("cancel");
        }
    }
}
</script>